import Panzoom from '@panzoom/panzoom'

const PanzoomHandler = {
    panzoom: null,
    rotation: 0,

    init(imageElement) {
        if (!imageElement) return;

        this.panzoom = Panzoom(imageElement, {
            maxScale: 4,
            minScale: 1,
            contain: "outside",
        });

        imageElement.parentElement.addEventListener("wheel", this.panzoom.zoomWithWheel);
    },

    zoomIn() {
        if (this.panzoom) this.panzoom.zoomIn();
    },

    zoomOut() {
        if (this.panzoom) this.panzoom.zoomOut();
    },

    rotateLeft(imageElement) {
        this.rotation -= 90;
        imageElement.style.transform = `rotate(${this.rotation}deg)`;
    },

    rotateRight(imageElement) {
        this.rotation += 90;
        imageElement.style.transform = `rotate(${this.rotation}deg)`;
    },

    reset(imageElement) {
        this.rotation = 0;
        imageElement.style.transform = "rotate(0deg)";
        if (this.panzoom) this.panzoom.reset();
    },

    destroy() {
        if (this.panzoom) {
            this.panzoom.destroy();
            this.panzoom = null;
        }
    },
};

export default PanzoomHandler;
